import type { IntegrationRequestDetail } from '../../../../models/IntegrationRequest';
import DetailCard from './DetailCard';

const RequestServicesCard = ({ services }: Pick<IntegrationRequestDetail, 'services'>) => (
  <DetailCard title='Servicios'>
    <ul className='text-sm text-gray-800 flex flex-col gap-1'>
      {services.map((service) => (
        <li key={service.id}>
          {service.name} <span className='text-gray-500'>({service.apiCode})</span>
          {service.isDefault && <span className='text-green-700'> · por defecto</span>}
        </li>
      ))}
    </ul>
  </DetailCard>
);

export default RequestServicesCard;
